import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import styled from "styled-components";
import ContactModal from "./ContactModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes, faUser } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    setShowUserMenu(false);
    navigate("/");
  };

  // Get the first letter of the user's first name; fallback "U"
  const firstLetter = user?.first_name ? user.first_name[0].toUpperCase() : "U";

  return (
    <HeaderContainer>
      <Nav>
        {/* Logo always centered */}
        <MobileRightSide>
          <LogoContainer>
            <Link to="/">
              <Logo src={`${process.env.PUBLIC_URL}/LOGO.svg`} alt="Company Logo" />
            </Link>
          </LogoContainer>

          {/* Mobile: Hamburger icon appears on the left */}
          <MobileMenuIcon onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
          </MobileMenuIcon>
        </MobileRightSide>
        

        {/* Desktop primary navigation links (visible on desktop only) */}
        <PrimaryNav>
          <StyledLink to="/">יעוץ משכנתא</StyledLink>
          <StyledLink to="/articles">מאמרים</StyledLink>
          <StyledLink to="/services">שירותים</StyledLink>
          <StyledLink to="/about">אודות</StyledLink>
          <StyledLink to="/real-estate-news">כתבות</StyledLink>
          <StyledLink to="/calculator">מחשבונים</StyledLink>
        </PrimaryNav>

        {/* Right container (always visible on both desktop & mobile) */}
        <RightContainer>
          {!user ? (
            <LoginButton onClick={() => navigate("/login")}>
              <FontAwesomeIcon icon={faUser} style={{ marginLeft: "5px" }} />
              התחברות
            </LoginButton>
          ) : (
            <AvatarWrapper>
              <UserAvatar onClick={() => setShowUserMenu(!showUserMenu)}>
                {firstLetter}
              </UserAvatar>
              {showUserMenu && (
                <DropDownMenu>
                  <DropDownItem
                    onClick={() => {
                      setShowUserMenu(false);
                      navigate("/user-settings");
                    }}
                  >
                    הגדרות משתמש
                  </DropDownItem>
                  <DropDownItem
                    onClick={() => {
                      setShowUserMenu(false);
                      navigate("/user-vip");
                    }}
                  >
                    פעולות נוספות
                  </DropDownItem>
                  <DropDownItem onClick={handleLogout}>
                    התנתק
                  </DropDownItem>
                </DropDownMenu>
              )}
            </AvatarWrapper>
          )}
          <CTAButton onClick={() => setIsModalOpen(true)}>
            צור קשר
          </CTAButton>
        </RightContainer>
      </Nav>

      {/* Mobile: Navigation links dropdown (visible on mobile when toggled) */}
      {isMobileMenuOpen && (
        <MobileNavLinks>
          <StyledLink to="/" onClick={() => setIsMobileMenuOpen(false)}>
            יעוץ משכנתא
          </StyledLink>
          <StyledLink to="/articles" onClick={() => setIsMobileMenuOpen(false)}>
            מאמרים
          </StyledLink>
          <StyledLink to="/services" onClick={() => setIsMobileMenuOpen(false)}>
            שירותים
          </StyledLink>
          <StyledLink to="/about" onClick={() => setIsMobileMenuOpen(false)}>
            אודות
          </StyledLink>
          <StyledLink to="/real-estate-news" onClick={() => setIsMobileMenuOpen(false)}>
            כתבות
          </StyledLink>
          <StyledLink to="/calculator" onClick={() => setIsMobileMenuOpen(false)}>
            מחשבונים
          </StyledLink>
        </MobileNavLinks>
      )}

      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </HeaderContainer>
  );
};


const MobileRightSide = styled.header`
display: flex;
`;
const HeaderContainer = styled.header`
  background: #f8f8f8;
  padding: 15px 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  border-bottom: 1px solid #e1e1e1;
  direction: rtl;
`;

const Nav = styled.nav`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: relative;
  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

const MobileMenuIcon = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    font-size: 1.5rem;
    color: #333;
    cursor: pointer;
  }
`;

const LogoContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    justify-content: center;
    margin-left:10px;
  }
`;

const Logo = styled.img`
  height: 50px;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
  @media (max-width: 768px) {
    height: 40px;
  }
`;

/* Primary navigation links (desktop only) */
const PrimaryNav = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

/* Right container always visible */
const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

/* Mobile navigation links dropdown */
const MobileNavLinks = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    width: 100%;
    padding: 20px 0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 100%;
    left: 0;
    gap: 10px;
  }
`;

const StyledLink = styled(Link)`
  color: #333;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  padding: 8px 10px;
  transition: color 0.3s ease;
  &:hover {
    color: #555;
  }
  &:after {
    content: "";
    display: block;
    height: 2px;
    background: #333;
    transition: width 0.3s ease;
    width: 0;
    margin-top: 5px;
  }
  &:hover:after {
    width: 100%;
  }
  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 12px 0;
  }
`;

const LoginButton = styled.button`
  background: #fff;
  padding: 10px 15px;
  font-size: 0.9rem;
  font-weight: bold;
  border: 2px solid #007bff;
  border-radius: 25px;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.3s ease, color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: #007bff;
    color: #fff;
    transform: scale(1.05);
  }
  &:active {
    transform: scale(1);
  }
`;

const CTAButton = styled.button`
  background: linear-gradient(135deg, #333, #555);
  color: white;
  padding: 10px 20px;
  font-size: 0.9rem;
  font-weight: bold;
  border: 1px solid #333;
  border-radius: 25px;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.3s ease;
  &:hover {
    background: linear-gradient(135deg, #555, #333);
    transform: scale(1.05);
  }
  &:active {
    transform: scale(1);
  }
`;

const AvatarWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  background: rgb(75 140 223);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  &:hover {
    background: #0056b3;
  }
`;

const DropDownMenu = styled.div`
  position: absolute;
  top: 110%;
  right: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  min-width: 140px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 999;
  animation: fadeIn 0.2s ease;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const DropDownItem = styled.div`
  padding: 10px 15px;
  font-size: 0.9rem;
  color: #333;
  cursor: pointer;
  text-align: right;
  &:hover {
    background: #f1f1f1;
  }
`;

export default Header;
